import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-amount-radio-group', 'AmountRadioGroup', component => {
  const radioInputs = component.element.querySelectorAll('input[type="radio"]')
  const customRadio = component.element.querySelector('.js-c-custom-amount-radio')
  const customInput = component.element.querySelector('.js-c-custom-amount-input')

  if (!customRadio) return

  radioInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (input === customRadio && customInput) {
        customInput.focus()
      }
    })
  })

  if (customInput) {
    customInput.addEventListener('input', () => {
      customRadio.value = customInput.value
    })

    customInput.addEventListener('focus', () => {
      if (!customRadio.checked) {
        customRadio.checked = true
        customRadio.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }
})
